import * as sterlingparker from './Selections.styles.sterlingparker';
import * as fiestabet from './Selections.styles.fiestabet';
import * as puntcity from './Selections.styles.puntcity';
import * as junglebet from './Selections.styles.junglebet';
import * as betroyale from './Selections.styles.betroyale';
import * as juicybet from './Selections.styles.juicybet';
import * as goldenrush from './Selections.styles.goldenrush';
import * as betprofessor from './Selections.styles.betprofessor';
import * as volcanobet from './Selections.styles.volcanobet';
import * as puntgenie from './Selections.styles.puntgenie';
import * as wellbet from './Selections.styles.wellbet';
import * as questbet from './Selections.styles.questbet';
import * as betgalaxy from './Selections.styles.betgalaxy';
import * as vikingbet from './Selections.styles.vikingbet';
import * as sugarcastle from './Selections.styles.sugarcastle';
import * as oldgill from './Selections.styles.oldgill';
import * as buffalobet from './Selections.styles.buffalobet';
import * as titanbet from './Selections.styles.titanbet';
import * as gigabet from './Selections.styles.gigabet';
import * as slambet from './Selections.styles.slambet';
import * as betstride from './Selections.styles.betstride';
import * as goldenbet888 from './Selections.styles.goldenbet888';
import * as hyperbet from './Selections.styles.hyperbet';
import * as bet777 from './Selections.styles.bet777';
import * as chromabet from './Selections.styles.chromabet';
import * as templebet from './Selections.styles.templebet';
import * as bet575 from './Selections.styles.bet575';
import * as epicodds from './Selections.styles.epicodds';
import * as pyramidbet from './Selections.styles.pyramidbet';
import * as magnumbet from './Selections.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  fiestabet,
  puntcity,
  junglebet,
  betroyale,
  juicybet,
  goldenrush,
  betprofessor,
  volcanobet,
  puntgenie,
  wellbet,
  questbet,
  betgalaxy,
  vikingbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  templebet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
